export default __webpack_public_path__ + "static/sustained_business-1267e8566c19acb2ca47402b6bc11467.mp4";